import { setRichText } from './icons.ts';

export type ToastKind = 'ok' | 'error';

/** Notification éphémère affichée dans un élément dédié. */
export class Toast {
  private readonly element: HTMLElement;
  private readonly durationMs: number;
  private timer: ReturnType<typeof setTimeout> | undefined;

  constructor(element: HTMLElement, durationMs = 3000) {
    this.element = element;
    this.durationMs = durationMs;
  }

  show(message: string, kind: ToastKind = 'ok'): void {
    setRichText(this.element, message);
    this.element.className = `show ${kind}`;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => { this.element.className = ''; }, this.durationMs);
  }
}
